/* Sur Le Lac — small runtime fixes (loaded after sll-custom.js) */
(function(){
  var TIKTOK='<svg class="sll-socials__tiktok" viewBox="0 0 302.7 348.4" aria-hidden="true"><path d="M0.2 233.5C3 168.1 63.9 120.6 127 131.6L126.2 195.6C114.9 192.7 104.4 191.9 93.9 195.5C70.5 203.6 56.1 227.5 61.4 252.9C65.5 272.4 81.7 288 101.3 291.1C127 295.2 149.7 280 157.5 255.9L158.6 222 158.7 29.1 159.3 0.3 215.5 0C218.9 52.2 251.2 80.4 302.2 86.5L302.3 144.6C271.7 143.7 243.3 134.8 218 117L217.2 244.8C215.6 288.2 186.8 325.4 148.7 340.1C105.9 356.7 58.9 345.6 28.7 312.5C8.8 290.7 -1.1 263.6 0.2 233.5Z"/></svg>';
  function flattenMenu(){
    var panel=document.querySelector('.header__inner > .drawer .primary-menu-panel');if(!panel)return;
    panel.querySelectorAll('button.menu-link').forEach(function(btn){
      if(btn.dataset.sllDone)return;btn.dataset.sllDone='1';
      var label=(btn.textContent||'').trim().toLowerCase();var href=null;
      document.querySelectorAll('.header__inner > .drawer .menu-panel').forEach(function(p){
        if(href)return;var h=p.querySelector('.menu-header');var a=h&&h.querySelector('a[href]');
        if(a&&(a.textContent||'').trim().toLowerCase()===label)href=a.getAttribute('href');
        if(!href&&h&&(h.textContent||'').trim().toLowerCase().indexOf(label)>-1){var a2=p.querySelector('a[href]');if(a2)href=a2.getAttribute('href')}
      });
      if(!href){var map={shop:'/collections/all',events:'/pages/events',lookbook:'/pages/lookbook',about:'/pages/about',contact:'/pages/contact'};href=map[label]||null}
      if(!href)return;
      var a=document.createElement('a');a.href=href;a.className=btn.className;a.textContent=btn.textContent.trim();btn.replaceWith(a);
    });
  }
  function alignMenu(){
    var logo=document.querySelector('.header__logo');var content=document.querySelector('.header__inner > .drawer .drawer__content--nav');
    if(!logo||!content)return;
    var r=logo.getBoundingClientRect();if(r.width<10)return;
    var img=logo.querySelector('img,svg');if(img){var ri=img.getBoundingClientRect();if(ri.width>10)r=ri}
    content.style.setProperty('--sll-logo-left',r.left+'px');content.style.setProperty('--sll-logo-w',r.width+'px');
  }
  function watchMenu(){
    var d=document.querySelector('.header__inner > .drawer');if(!d)return;
    new MutationObserver(alignMenu).observe(d,{attributes:true,subtree:true,attributeFilter:['class','open']});
    window.addEventListener('resize',alignMenu);window.addEventListener('load',alignMenu);
  }
  /* Menu socials: Instagram + TikTok only (are.na / Pinterest parked until those accounts exist) */
  function socials(){
    var row=document.querySelector('.header__inner > .drawer .sll-socials');if(!row||row.dataset.sllTt)return;
    var links=Array.prototype.slice.call(row.querySelectorAll('a'));if(!links.length)return;
    row.dataset.sllTt='1';
    links.forEach(function(a,i){
      var h=(a.getAttribute('href')||'').toLowerCase();var ig=h.indexOf('instagram')>-1||i===0;
      if(!ig)a.classList.add('sll-hide');
    });
    var tt=document.createElement('a');tt.href='https://www.tiktok.com/@surlelac.co';tt.target='_blank';tt.rel='noopener';tt.setAttribute('aria-label','TikTok');tt.className='sll-socials__tt';tt.innerHTML=TIKTOK;
    row.appendChild(tt);
  }
  /* Empty-cart "Start shopping" points at /collections (the collection LIST page, which
     renders empty here). Send it to the actual shop instead — covers the cart page and
     the drawer, including the drawer's late-rendered markup. */
  function cartLink(){
    var isList=function(h){return /^\/collections\/?$/.test((h||'').split('?')[0])};
    document.querySelectorAll('a[href]').forEach(function(a){if(isList(a.getAttribute('href')))a.setAttribute('href','/collections/all')});
    document.addEventListener('click',function(e){
      var a=e.target&&e.target.closest?e.target.closest('a[href]'):null;if(!a)return;
      if(!isList(a.getAttribute('href')))return;
      e.preventDefault();window.location.href='/collections/all';
    },true);
  }
  function syncAlbumTop(){
    var alb=document.querySelector('.sll-album');if(!alb)return;
    var hg=document.querySelector('.shopify-section-group-header-group');var top=70;
    if(hg){var rr=hg.getBoundingClientRect();if(rr.height>0)top=Math.max(0,Math.round(rr.bottom))}
    alb.style.top=top+'px';alb.style.setProperty('--sll-album-top',top+'px');
  }
  function watchAlbum(){
    new MutationObserver(function(){if(document.querySelector('.sll-album'))syncAlbumTop()}).observe(document.body,{childList:true,attributes:true,attributeFilter:['class']});
    window.addEventListener('resize',syncAlbumTop);
  }
  /* PDP gallery pagination: update every frame while the rail scrolls */
  function fastPag(){
    var raf=null;
    document.addEventListener('scroll',function(e){
      var r=e.target;if(!r||!r.classList||!r.classList.contains('sll-gal__rail'))return;
      if(raf)return;
      raf=requestAnimationFrame(function(){
        raf=null;var gal=r.parentElement;var pag=gal&&gal.querySelector('.sll-gal__pag');if(!pag)return;
        var c=r.scrollLeft+r.clientWidth/2;var best=0,bd=1e9;
        Array.prototype.forEach.call(r.children,function(s,i){var d=Math.abs(s.offsetLeft+s.offsetWidth/2-c);if(d<bd){bd=d;best=i}});
        Array.prototype.forEach.call(pag.children,function(b,i){b.classList.toggle('swiper-pagination-bullet-active',i===best)});
      });
    },true);
  }
  /* toast */
  var toastEl=null,toastT=null;
  function toast(msg,ms){if(!toastEl){toastEl=document.createElement('div');toastEl.className='sll-toast';document.body.appendChild(toastEl)}toastEl.textContent=msg;requestAnimationFrame(function(){toastEl.classList.add('is-on')});clearTimeout(toastT);toastT=setTimeout(function(){toastEl.classList.remove('is-on')},ms||5000)}
  /* Newsletter: pending state on submit, confirmation after the reload, popup memory */
  function newsletterUX(){
    var posted=/customer_posted=true/.test(location.search);
    var np=document.querySelector('newsletter-popup');
    var done=false,dismissed=false;
    try{done=!!localStorage.getItem('sll-np-subscribed');dismissed=!!sessionStorage.getItem('sll-np-dismissed')}catch(e){}
    if(posted){
      try{localStorage.setItem('sll-np-subscribed','1')}catch(e){}
      done=true;
      toast('You\u2019re in. Your 15% code is on its way.',6000);
      try{var u=new URL(location.href);u.searchParams.delete('customer_posted');u.searchParams.delete('form_type');u.hash='';history.replaceState(null,'',u.pathname+(u.search||''))}catch(e){}
    }
    document.querySelectorAll('.newsletter-form').forEach(function(f){
      f.addEventListener('submit',function(){
        var b=f.querySelector('button[type=submit],.button');if(b){b.textContent='Sending';b.style.opacity='.6';b.disabled=true}
        try{localStorage.setItem('sll-np-subscribed','1')}catch(e){}
      });
    });
    /* "Subscribe" text is a real submit control: delegated so the late-rendered popup form is covered too */
    document.addEventListener('click',function(e){
      var b=e.target.closest('.newsletter-form .field__input-wrapper .button, .newsletter-form button[type=submit]');if(!b)return;
      var f=b.closest('form');if(!f||b.disabled)return;
      e.preventDefault();
      var inp=f.querySelector('input[type=email]');
      if(inp&&!inp.value.trim()){inp.focus();return}
      if(f.requestSubmit){f.requestSubmit(b)}else{f.submit()}
    },true);
    if(!np)return;
    if(done||dismissed){np.remove();return}
    np.addEventListener('click',function(e){
      var t=e.target.closest('button,a');if(!t)return;
      var txt=(t.textContent||'').trim().toLowerCase();
      if(t.matches('[class*=close],[aria-label*="lose"]')||txt==='no thanks'){try{sessionStorage.setItem('sll-np-dismissed','1')}catch(e){}}
    },true);
  }
  function annSync(){var hero=document.querySelector('.hero-banner');document.body.classList.toggle('sll-at-top',!!hero&&window.scrollY<24);document.body.classList.toggle('sll-has-hero',!!hero)}
  function watchAnn(){var t=false;window.addEventListener('scroll',function(){if(!t){t=true;requestAnimationFrame(function(){t=false;annSync()})}},{passive:true});annSync()}
  function init(){flattenMenu();alignMenu();watchMenu();socials();cartLink();watchAlbum();watchAnn();fastPag();newsletterUX();setTimeout(socials,300)}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
  document.addEventListener('shopify:section:load',function(){flattenMenu();alignMenu();socials();cartLink();annSync()});
})();
